import universal from 'react-universal-component';
import universalImport from 'babel-plugin-universal-import/universalImport';
import path from 'path';
import { timeout } from 'yoda-site-components/lib/lazy/lazyConstants';

export default universal(
    universalImport({
        chunkName: () => 'DynamicVisNavLazy',
        path: () => path.join(__dirname, './DynamicVisNav'),
        resolve: () => require.resolveWeak('./DynamicVisNav'),
        load: () =>
            Promise.all([
                import(/* webpackChunkName: "DynamicVisNavLazy" */ './DynamicVisNav'),
            ]).then((proms) => proms[0]),
    }),
    {
        loading: () => null,
        error: () => null,
        timeout,
    }
);
